import { render } from "./StepTextMessage.vue?vue&type=template&id=71725b57&scoped=true"
import script from "./StepTextMessage.vue?vue&type=script&lang=js"
export * from "./StepTextMessage.vue?vue&type=script&lang=js"

import "./StepTextMessage.vue?vue&type=style&index=0&id=71725b57&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71725b57"]])

export default __exports__